const CHUNK_ERROR_RELOAD_KEY = "chunk_error_reload";

const isChunkLoadError = (error: Error) => {
  return (
    error?.message?.includes("Importing a module script failed") ||
    error?.message?.includes("Failed to fetch dynamically imported module") ||
    error?.message?.includes("error loading dynamically imported module") ||
    error?.message?.includes("Unable to preload CSS for")
  );
};

export default defineNuxtPlugin(() => {
  const router = useRouter();

  router.onError((error, to) => {
    if (!isChunkLoadError(error)) return;

    // Avoid infinite reload loop: only reload once per destination path
    const reloadedPath = sessionStorage.getItem(CHUNK_ERROR_RELOAD_KEY);
    const targetPath = to.fullPath;

    if (reloadedPath === targetPath) {
      sessionStorage.removeItem(CHUNK_ERROR_RELOAD_KEY);
      console.warn("[chunk-error] Chunk load failed after reload attempt — navigating to home.", error);
      window.location.href = "/";
      return;
    }

    sessionStorage.setItem(CHUNK_ERROR_RELOAD_KEY, targetPath);
    window.location.href = targetPath;
  });
});
